/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SuccessResponse = {
  success?: boolean | undefined;
};

/** @internal */
export const SuccessResponse$inboundSchema: z.ZodType<
  SuccessResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  success: z.boolean().optional(),
});
/** @internal */
export type SuccessResponse$Outbound = {
  success?: boolean | undefined;
};

/** @internal */
export const SuccessResponse$outboundSchema: z.ZodType<
  SuccessResponse$Outbound,
  z.ZodTypeDef,
  SuccessResponse
> = z.object({
  success: z.boolean().optional(),
});

export function successResponseToJSON(
  successResponse: SuccessResponse,
): string {
  return JSON.stringify(SuccessResponse$outboundSchema.parse(successResponse));
}
export function successResponseFromJSON(
  jsonString: string,
): SafeParseResult<SuccessResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SuccessResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SuccessResponse' from JSON`,
  );
}
